module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "produk-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'OSS Configs',
          to: {
            path: '/landing-packages'
          },
          exact: true,
        },
        {
          text: 'Paket Landing Page',
          to: {
            path: '/landing-packages'
          },
          exact: true,
        },
        {
          text: _vm.category.category_name,
          to: {
            path: '/landing-packages/' + _vm.category.id
          },
          exact: true,
        },
        {
          text: 'Ubah Paket'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Ubah Paket")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "plain": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    ID *\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": ""
    },
    model: {
      value: (_vm.data.id),
      callback: function($$v) {
        _vm.$set(_vm.data, "id", $$v)
      },
      expression: "data.id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    ID Paket *\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": ""
    },
    model: {
      value: (_vm.data.id_paket),
      callback: function($$v) {
        _vm.$set(_vm.data, "id_paket", $$v)
      },
      expression: "data.id_paket"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    ID Kelas *\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": ""
    },
    model: {
      value: (_vm.id_kelas),
      callback: function($$v) {
        _vm.id_kelas = $$v
      },
      expression: "id_kelas"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Deskripsi *\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": ""
    },
    model: {
      value: (_vm.data.deskripsi),
      callback: function($$v) {
        _vm.$set(_vm.data, "deskripsi", $$v)
      },
      expression: "data.deskripsi"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Subscription Type *\n                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Jenis",
      "outlined": "",
      "items": [{
          text: 'Tahunan',
          value: '1 TAHUN'
        },
        {
          text: 'Bulanan',
          value: '1 BULAN'
        } ]
    },
    model: {
      value: (_vm.data.type),
      callback: function($$v) {
        _vm.$set(_vm.data, "type", $$v)
      },
      expression: "data.type"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pt-0 px-0 pb-6"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Fitur *\n                ")]), _vm._v(" "), _vm._l((_vm.data.fitur), function(fitur, i) {
    return _c('v-text-field', {
      key: i,
      staticClass: "pb-2",
      attrs: {
        "hide-details": "",
        "disabled": _vm.queryId,
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function() {
          return [(
            i === _vm.data.fitur.length - 1 &&
            _vm.data.fitur.length != 1
          ) ? _c('v-btn', {
            staticClass: "font-weight-bold dark--text py-3",
            attrs: {
              "text": "",
              "color": "redLight"
            },
            on: {
              "click": function($event) {
                return _vm.data.fitur.splice(i, 1)
              }
            }
          }, [_vm._v("\n                            Hapus\n                        ")]) : _vm._e()]
        },
        proxy: true
      }], null, true),
      model: {
        value: (_vm.data.fitur[i]),
        callback: function($$v) {
          _vm.$set(_vm.data.fitur, i, $$v)
        },
        expression: "data.fitur[i]"
      }
    })
  }), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    staticClass: "font-weight-bold blew--text",
    attrs: {
      "elevation": "1",
      "disabled": _vm.queryId,
      "block": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.data.fitur.push('')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                        Tambah Fitur\n                    ")], 1)], 1)], 2)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0 mt-6"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Harga Normal\n                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "text",
      "prefix": "Rp",
      "outlined": "",
      "separator": ","
    },
    model: {
      value: (_vm.data.harga_normal),
      callback: function($$v) {
        _vm.$set(_vm.data, "harga_normal", $$v)
      },
      expression: "data.harga_normal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Harga Asli *\n                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "text",
      "prefix": "Rp",
      "outlined": "",
      "separator": ","
    },
    model: {
      value: (_vm.data.harga_asli),
      callback: function($$v) {
        _vm.$set(_vm.data, "harga_asli", $$v)
      },
      expression: "data.harga_asli"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Potongan Referral\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "prefix": "Rp",
      "outlined": "",
      "separator": ",",
      "value": _vm.data.referral_discount = Number(
        _vm.data.referral_discount
      )
    },
    model: {
      value: (_vm.data.referral_discount),
      callback: function($$v) {
        _vm.$set(_vm.data, "referral_discount", $$v)
      },
      expression: "data.referral_discount"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Diskon\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "prefix": "%",
      "outlined": ""
    },
    model: {
      value: (_vm.data.diskon),
      callback: function($$v) {
        _vm.$set(_vm.data, "diskon", $$v)
      },
      expression: "data.diskon"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    URL\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": ""
    },
    model: {
      value: (_vm.data.link),
      callback: function($$v) {
        _vm.$set(_vm.data, "link", $$v)
      },
      expression: "data.link"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.data.type) ? _c('v-card-actions', {
    staticClass: "py-2"
  }, [_c('v-spacer'), _vm._v(" "), (!_vm.$route.query.id) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("\n                Simpan\n            ")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d9f9ede","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/oss_configs/components/landing_package/Form.vue
// module id = 1919
// module chunks = 1